import * as z from "zod";

const LogFunction = z.function({
  input: z.array(z.unknown()),
  output: z.void(),
});

/** A Zod schema around {@link Console} */
export const Logger = z.object({
  debug: LogFunction,
  error: LogFunction,
  info: LogFunction,
  log: LogFunction,
  warn: LogFunction,
});

export interface Logger extends z.output<typeof Logger> {}

export default globalThis.console satisfies Logger;
